import React, { useState } from 'react';
import { Card, CardBody, FormGroup, Label } from 'reactstrap';
import { ReactComponent as DeleteIcon } from '../../../../../assets/utils/images/svgs/Delete.svg';
import SweetAlert from 'react-bootstrap-sweetalert';

const AfasGebruikers = ({ users = [], onRemove }) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    return (
        <Card className="main-card pb-4">
            <CardBody className="d-flex flex-column">
                <div className="btn-color-style travelCost-blue-text mb-4">
                    Afas gebruikers
                </div>

                {users.length > 0 ? (
                    <div className="melder-list" style={{ overflowX: 'hidden' }}>
                        {users.map((user) => (
                            <FormGroup key={user.id || user.iAdminId}>
                                <div className="d-flex justify-content-between align-items-center">
                                    <Label className="mb-0">{user.name}</Label>
                                    <div
                                        onClick={() => {
                                            setSelectedUser(user);
                                            setShowDeleteModal(true);
                                        }}
                                        className="d-flex svg-pointer"
                                        role="button"
                                        tabIndex={0}
                                        aria-label={`Verwijder ${user.name}`}
                                    >
                                        <DeleteIcon />
                                    </div>
                                </div>
                            </FormGroup>
                        ))}
                    </div>
                ) : (
                    <p className="text-center mb-0">Geen AFAS gebruikers</p>
                )}
            </CardBody>

            <SweetAlert
                title="Weet je zeker dat je deze AFAS gebruiker wilt verwijderen?"
                show={showDeleteModal}
                type="warning"
                confirmBtnText="OK"
                cancelBtnText="Annuleren"
                showCancel
                onConfirm={() => {
                    if (selectedUser) {
                        onRemove?.(selectedUser.iAdminId);
                    }
                    setShowDeleteModal(false);
                    setSelectedUser(null);
                }}
                onCancel={() => {
                    setShowDeleteModal(false);
                    setSelectedUser(null);
                }}
            />
        </Card>
    );
};

export default AfasGebruikers;
